export const AcSanitize = (input, character = '') => {
	return input.replace(/[^A-Z0-9]+/gi, character);
};

export default AcSanitize;
